import { isObject } from '../isObject/isObject';

export const isEmptyObject = (value: any): boolean =>
  isObject(value) && !Object.keys(value).length;
